import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_auto_email_eligible_lot_expirationsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { lot_expiration_days_before_expiry?: number, projectId?: number, rule_id: string, $top?: number, $skip?: number }): Promise<{ result?: { lot_id?: number, lookup_code?: string, warehouse_id?: number }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.rule_id)) {
      missingRequiredInParams.push('\'rule_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_auto_email_eligible_lot_expirations/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lot_expiration_days_before_expiry?: number, projectId?: number, rule_id?: string, $keys: number[] }): Promise<{ result?: { lot_id?: number, lookup_code?: string, warehouse_id?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_auto_email_eligible_lot_expirations/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      lot_expiration_days_before_expiry?: number, projectId?: number, rule_id: string    }) {
        if(isNil(inParams.rule_id)) {
          return true; 
        }
      return false;
    }
}
